export class ProgramDetailsPromoCodeRequests {
    total: number;
    new: number;
    submitted: number;
    tier1Approved: number;
    tier2Approved: number;
    rejected: number;
    modified: number;
    closedCanceled: number;
}

export class PrgramDetailsFundingSource {
    id: number;
    brandName: string;
    brandId: number;
    estimatedFundingPercentage: string;
    estimatedAtl: string;
    estimatedBtl: string;
    estimatedTotal: string;
    invoicedAtl: string;
    invoicedBtl: string;
    invoicedTotal: string;
    programId: number;
}

export class ProgramDetailsTacticComponent {
    public id: number;
    public component: string;
    public vendor: string;
    public estimatedAtl: number;
    public estimatedBtl: number;
    public estimatedTotal: number;
    public invoiceAtl: number;
    public invoiceBtl: number;
    public invoiceTotal: number;
    public vendorId: number;
    public programTacticId: number;
    public total: number;
    public isMasterEntry: number;
    public componentTypeID: number;
    public couponStartDate: Date;
    public couponExpDate: Date;
    public startDate: Date;
    public endDate: Date;
    public contributingBrands: string;
    public hovered: boolean;
    public showCloseComponentButton: number;
}

export class ProgramDetailsTactic {
    id: number;
    name: string;
    startDate: Date;
    endDate: Date;
    estimatedAtl?: any;
    estimatedBtl?: any;
    estimatedTotal?: any;
    total?: any;
    invoiceAtl?: any;
    invoiceBtl?: any;
    invoiceTotal?: any;
    shopTypeId?: number;
    tacticTypeId?: number;
    programId: number;
    programDetailsTacticComponent: ProgramDetailsTacticComponent[];
    opened = true;
    description: string;
    uniPriSMUpgrade: boolean;
    public hovered: boolean;
}

export class ProgramDetailsDto {
    public id: number;
    public programName: string;
    public programStartDate: Date;
    public programEndDate: Date;
    public billSAP?: any;
    public programStatusDesc: string;
    public strategicBusinessInitiative: string;
    public programDescription: string;
    public note?: any;
    public programBudgetStatus?: any;
    public programType: string;
    public creator: string;
    public approver: string;
    public title: string;
    public approvedDate?: any;
    public programDetailsPromoCodeRequests: ProgramDetailsPromoCodeRequests;
    public prgramDetailsFundingSources: PrgramDetailsFundingSource[];
    public programDetailsTactic: ProgramDetailsTactic[];
    public promoCodes: PromoCode[];
    public budgetYear: number;
    public retailerId: number;
    public programExecStatusId: number;
    public programExecStatusDesc: string;
    public programStatusID: number;
    public strategicBusinessInitiativeId: number;
    public retailer: string;
    public sector: string;
    public subsector: string;
    public uniPriSMUpgrade: boolean;
    public jtbd: string;
}

export class PromoCode {
    id: number;
    vendorPromoCode: string;
    promoCodeStatusDesc: string;
    brandName: string;
    budgetTypeDesc: string;
    atlbtl: string;
    redemptionValue: number;
    redDetailCirculation: number;
    estimatedRedemption: number;
    maximumValue: number;
    ytdDollars: string;
    programId: number;
    programFundingId: number;
    budgetTypeId: number;
    promoCodeID: number;
    promoCodeStatusID: number;
    public statusInfo: Array<any> = [];
    public hovered: boolean;
}

export class PromoCodeDto {
    id: number;
    programId: number;
    promoCodeId: number;
    promoCodeStatusId: number;
    programFundingDetailsId: number;
    budgetTypeId: number;
    atlbtl: string;
    value: number;
    redDetailCirculation: number;
    estimatedRedemption: number;
    maximumValue: number;
    ytdSpend: number;
    promoCode: number;
    programFundingName: string;
    public promoCodeStatusDesc: string;
    vendorPromoCode: string;
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/program-details.ts